module.exports = __webpack_public_path__ + "img/flyable.9ea0737c.svg";